// 1) Init Splide without giving clones an “is-active” class
const splide = new Splide("#splide", {
  cloneStatus: false,
}).mount();

// Smooth class toggle with requestAnimationFrame to reduce layout thrash
splide.on('move', (newIndex) => {
  requestAnimationFrame(() => {
    const slides = splide.Components.Elements.slides;
    slides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === newIndex);
    });
  });
});


// 2) Tag every <video> with its own muted flag
document.querySelectorAll(".splide__slide video").forEach((video) => {
  if (video.dataset.muted === undefined) {
    video.dataset.muted = "true";
    video.muted = true;
  }
});

// 3) Mute-toggle helpers (unchanged)
function toggleMute(video, btn) {
  const muted = !video.muted;
  video.muted = muted;
  video.dataset.muted = String(muted); // ensure it's "true"/"false"
  btn.classList.toggle("is-muted", muted);
  btn.querySelector(".icon-mute").style.display = muted ? "block" : "none";
  btn.querySelector(".icon-unmute").style.display = muted ? "none" : "block";
}

function updateButton(video, btn) {
  const muted = video.dataset.muted === "true";
  video.muted = muted;
  btn.classList.toggle("is-muted", muted);
  btn.querySelector(".icon-mute").style.display = muted ? "block" : "none";
  btn.querySelector(".icon-unmute").style.display = muted ? "none" : "block";
}

function bindButtons() {
  document.querySelectorAll(".splide__slide").forEach((slide) => {
    const video = slide.querySelector("video");
    const btn = slide.querySelector(".video-mute-toggle");
    if (!video || !btn) return;
    updateButton(video, btn);
    btn.onclick = () => toggleMute(video, btn);
  });
}

// 4) On initial mount, play the first slide’s video and bind buttons
splide.on("mounted", () => {
  const firstSlide = splide.Components.Elements.slides[splide.index];
  const vid = firstSlide?.querySelector("video");
  if (vid) vid.play().catch(() => {});
  bindButtons();
});

// 5) On *start* of each move, pause the outgoing video and kick off play() on the incoming one
splide.on("move", (newIndex) => {
  const slides = splide.Components.Elements.slides;
  slides.forEach((slide, idx) => {
    const video = slide.querySelector("video");
    if (!video) return;

    if (idx === newIndex) {
      // Incoming slide → restore mute flag & play
      video.muted = video.dataset.muted === "true";
      video.play().catch(() => {});
    } else {
      // Outgoing slides → pause
      video.pause();
    }
  });

  bindButtons();
});

// 6) If the tab regains focus, make sure the current slide’s video is playing
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) {
    const slide = splide.Components.Elements.slides[splide.index];
    const vid = slide?.querySelector("video");
    if (vid && vid.paused) vid.play().catch(() => {});
    bindButtons();
  }
});

function setSpinner(video, show) {
  const section = video.closest(".video-section");
  const spinner = section?.querySelector(".video-spinner");
  const overlay = section?.querySelector(".video-spinner-overlay");
  if (spinner) {
    spinner.style.display = show ? "block" : "none";
  }
  if (overlay) {
    overlay.style.display = show ? "block" : "none";
  }
}

function wireUpSpinners() {
  document.querySelectorAll(".splide__slide video").forEach((video) => {
    // Hide initially
    setSpinner(video, false);

    // Show when buffering
    video.addEventListener("waiting", () => {
      setSpinner(video, true);
    });

    // Hide when ready to play or playing
    ["playing", "canplay", "canplaythrough", "loadeddata"].forEach((evt) => {
      video.addEventListener(evt, () => {
        setSpinner(video, false);
      });
    });

    // Optional: Show on error
    video.addEventListener("error", () => {
      setSpinner(video, true);
    });
  });
}

wireUpSpinners();

// Initial button + first-slide sync
bindButtons();
{
  const slide = splide.Components.Elements.slides[splide.index];
  if (slide) {
    const vid = slide.querySelector("video");
    const btn = slide.querySelector(".video-mute-toggle");
    if (vid) {
      vid.muted = vid.dataset.muted === "true";
      vid.play().catch(() => {});
    }
    if (vid && btn) {
      updateButton(vid, btn);
    }
  }
}

/**
 * Viewport-based mute:
 * - While #slider is visible: no behavior change.
 * - When #slider fully leaves viewport: force-mute all its videos.
 */
(function setupViewportMuteGuard() {
  const section = document.querySelector("#slider");
  if (!section) return;

  const muteAllInSection = () => {
    section.querySelectorAll(".splide__slide video").forEach((video) => {
      const slide = video.closest(".splide__slide");
      const btn = slide?.querySelector(".video-mute-toggle");

      video.muted = true;
      video.dataset.muted = "true";
      if (btn) updateButton(video, btn);
    });
  };

  const syncIcons = () => {
    section.querySelectorAll(".splide__slide video").forEach((video) => {
      const slide = video.closest(".splide__slide");
      const btn = slide?.querySelector(".video-mute-toggle");
      if (btn) updateButton(video, btn);
    });
  };

  const handleVisibility = (inView) => {
    if (!inView) {
      // Out of viewport → hard mute
      muteAllInSection();
    } else {
      // Back in viewport → keep whatever mute state is stored (we just sync icons)
      syncIcons();
    }
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const inView = entry.isIntersecting && entry.intersectionRatio > 0;
          handleVisibility(inView);
        });
      },
      {
        threshold: 0.01, // treat as "visible" if any sliver is on screen
      }
    );

    observer.observe(section);
  } else {
    // Fallback: scroll/resize
    const check = () => {
      const rect = section.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < window.innerHeight;
      handleVisibility(inView);
    };
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    check();
  }
})();
